export default class NewsletterSuccessPopup {
  constructor(component) {
    this.dom = {
      $component: component,
      $popupBox: document.querySelector('.js-popupBox'),
      $underlay: document.querySelector('.js-newsletterSuccessUnderlay'),
      $popupClose: document.querySelector('.js-popupClose')
    }
    this.state = {
      underlayActiveClass: 'isActive',
      popupActiveClass: 'isActive'
    }
    this.submitSuccessHandler = this.submitSuccess.bind(this)
    this.closePopupHandler = this.closePopup.bind(this)

    this.mount()
    this.bindToWindow()
  }

  mount() {
    const { dom } = this
    document.addEventListener('newsletterSubmitSuccess', this.submitSuccessHandler)
    dom.$underlay.addEventListener('click', this.closePopupHandler)
    dom.$popupClose.addEventListener('click', this.closePopupHandler)
  }

  submitSuccess() {
    const { dom, state } = this
    dom.$underlay.classList.add(state.underlayActiveClass)
    dom.$popupBox.classList.add(state.popupActiveClass)
  }

  closePopup() {
    const { dom, state } = this
    dom.$underlay.classList.remove(state.underlayActiveClass)
    dom.$popupBox.classList.remove(state.popupActiveClass)
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.NewsletterSuccessPopup = this
  }
}
